function removepopup() {
    $('.overlay').animate({'opacity':'0'}, 300, 'linear', function(){
        $('.overlay').css('display', 'none');
    });
    $('.popupform').fadeOut().css('display', 'none');
    $('#main').css('z-index',0);
}
jQuery(document).ready(function ($) {




    if($('.product__primary').length >0){

        if(window.innerWidth < 919){
            setTimeout(function(){
                $('.product__media').css('min-height', window.innerWidth);
              }, 2000);
            
        }

    

    }
  if($('.ring-size-container').length >0){
    $('.ring-size-container').insertAfter($('.product-form__quantity'));
  }
    //ring size
    $('.ring-size input[type="radio"]').click(function(){
        $('.ring-size-btn').text($(this).attr('value'));
  removepopup();
  $('.ring-size-container .error-msg').hide();
});
$('.product-form button[type="submit"]').click(function() {

  if($('.ring-size-btn').text()=="Select a Ring Size"){ $('.ring-size-container .error-msg').show(); $('.raido-btn-container').css('border', 'solid 1px red'); return false;}
  else{   $('.raido-btn-container .error-msg').hide(); $('.raido-btn-container').css('border', 'solid 1px #000'); return true;}
  $('.raido-btn-container').css('border', 'solid 1px #000');
});  


      $('.popup-btn').click(function(){
          var formname = $(this).attr('popup');
          $('#main').css('z-index',510);
          $('.overlay').animate({'opacity':'.50'}, 300, 'linear').css('display', 'block');
          $('.'+formname).fadeIn();
          console.log('popshow'+formname);
      });
    $('body').on('click', '.overlay', function(){removepopup()});
    $('body').on('click', '.cancel-btn', function(){removepopup()});
});
